interface SectionTitleProps {
  title: string;
  subtitle?: string;
  accent?: 'primary' | 'accent' | 'secondary';
  className?: string;
}

export default function SectionTitle({ title, subtitle, accent = 'primary', className = '' }: SectionTitleProps) {
  const accentColors = {
    primary: 'text-primary-500',
    accent: 'text-accent-500',
    secondary: 'text-secondary-500',
  };

  return (
    <div className={`text-center mb-10 ${className}`}>
      <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3 tracking-wider">
        <span className={accentColors[accent]}>「 </span>
        {title}
        <span className={accentColors[accent]}> 」</span>
      </h2>
      {subtitle && (
        <p className="text-foreground-500 text-sm max-w-xl mx-auto">{subtitle}</p>
      )}
    </div>
  );
}